import { render, staticRenderFns } from "./PictureUpload.vue?vue&type=template&id=dd0dafa2&scoped=true"
import script from "./PictureUpload.vue?vue&type=script&lang=ts"
export * from "./PictureUpload.vue?vue&type=script&lang=ts"
import style0 from "./PictureUpload.vue?vue&type=style&index=0&id=dd0dafa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0dafa2",
  null
  
)

export default component.exports